export default function limiteTamanhoCampos(campo, valor, apenasNumero, maiusculo = true) {

    const camposNaoMaiusculo = ['tipoFiliacao', 'menorDe15', 'falecido', 'sociedadeCompositorAutor', 'sociedadeInterprete', 'sociedadeMusico', 'sociedadeProdutor', 'sociedadeEditor', 'territorioAdmAutorais', 'territorioAdmConexao', 'musicasPublicas', 'links'];

    if (apenasNumero)
        valor = valor.replace(/\D/g, '');

    if (typeof valor == 'string' && !camposNaoMaiusculo.includes(campo) && maiusculo)
        valor = valor.toUpperCase();

    switch (campo) {
        case 'nomeCompleto': return _substring(valor, 60);
        case 'razaoSocial': return _substring(valor, 60);
        case 'nomeArtistico': return _substring(valor, 100);
        case 'nomeFantasia': return _substring(valor, 100);
        case 'pseudonimoColetivo': return _substring(valor, 100);
        case 'cpf': return _substring(valor.replace(/\D/g, ''), 14);
        case 'cnpj': return _substring(valor.replace(/\D/g, ''), 14);
        case 'identidade': return _substring(valor, 15);
        case 'orgaoExpedidor': return _substring(valor, 32);
        // case 'nacionalidade': return {
        //     id: valor.id,
        //     nome: _substring(valor.nome, 32)
        // };
        case 'naturalidade': return _substring(valor, 32);
        case 'genero': return _substring(valor, 1);
        case 'estadoCivil': return _substring(valor, 1);
        case 'endereco': return _substring(valor, 25);
        case 'numero': return _substring(valor, 8);
        case 'complemento': return _substring(valor, 25);
        case 'bairro': return _substring(valor, 40);
        case 'cidade': return _substring(valor, 32);
        case 'estado': return _substring(valor, 2);
        case 'cep': return _substring(valor.replace(/\D/g, ''), 8);
        case 'telefone': return _substring(valor.replace(/\D/g, ''), 16);
        case 'celular': return _substring(valor.replace(/\D/g, ''), 16);
        case 'email': return _substring(valor, 64);
        case 'linkedin': return _substring(valor, 64);
        case 'site': return _substring(valor, 64);
        case 'facebook': return _substring(valor, 64);
        case 'instagram': return _substring(valor, 64);
        case 'tiktok': return _substring(valor, 64);
        case 'xantigoTwitter': return _substring(valor, 64);
        case 'youtube': return _substring(valor, 64);
        case 'threads': return _substring(valor, 64);
        case 'spotify': return _substring(valor, 64);
        case 'deezer': return _substring(valor, 64);
        case 'bancoNacional': return _substring(valor, 128);
        case 'CdBanco': return _substring(valor, 6);
        case 'bancoAgenciaNacional': return _substring(valor, 8);
        case 'bancoAgenciaDvNacional': return _substring(valor, 1);
        case 'bancoContaNacional': return _substring(valor, 10);
        case 'bancoContaDvNacional': return _substring(valor, 1);
        case 'bancoTipoContaNacional': return _substring(valor, 2);
        case 'bancoNaturezaContaNacional': return _substring(valor, 1);
        case 'bancoPosicaoContaNacional': return _substring(valor, 1);
        case 'bancoInternacional': return _substring(valor, 50);
        case 'bancoAgenciaInternacional': return _substring(valor, 50);
        case 'bancoContaInternacional': return _substring(valor, 50);
        case 'bancoSwiftInternacional': return _substring(valor, 11);
        case 'bancoIbanInternacional': return _substring(valor, 34);
        case 'sobreCarreira': return _substring(valor, 250);
        case 'comoConheceuUBC': return _substring(valor, 32);
        case 'contatoAtendimento': return _substring(valor, 32);
        case 'quemIndicouUBC': return _substring(valor, 32);
        case 'musicasPublicas': return _substring(valor, 32);
        case 'links': return _substring(valor, 250);
        case 'territorioAdmAutoraisOutro': return _substring(valor, 100);
        case 'territorioAdmConexaoOutro': return _substring(valor, 100);
        case 'sociedadeCompositorAutor': return _substring(valor, 100);
        case 'sociedadeInterprete': return _substring(valor, 100);
        case 'sociedadeMusico': return _substring(valor, 100);
        case 'sociedadeProdutor': return _substring(valor, 100);
        case 'sociedadeEditor': return _substring(valor, 100);


        case 'nomeOutorganteFalecido': return _substring(valor, 128);
        // case 'nacionalidadeOutorganteFalecido': return {
        //     id: valor.id,
        //     nome: _substring(valor.nome, 32)
        // };
        case 'estadoCivilOutorganteFalecido': return _substring(valor, 1);
        case 'rgOutorganteFalecido': return _substring(valor, 15);
        case 'rgOEOutorganteFalecido': return _substring(valor, 32);
        case 'cpfOutorganteFalecido': return _substring(valor.replace(/\D/g, ''), 14);
        case 'naturezaJuridicaDocOutorganteFalecido': return _substring(valor, 50);
        case 'varaOutorganteFalecido': return _substring(valor, 100);
        case 'comarcaOutorganteFalecido': return _substring(valor, 50);
        case 'endecoOutorganteFalecido': return _substring(valor, 128);
        case 'numeroOutorganteFalecido': return _substring(valor, 8);
        case 'complementoOutorganteFalecido': return _substring(valor, 64);
        case 'bairroJuridicaDocOutorganteFalecido': return _substring(valor, 64);
        case 'cidadeJuridicaDocOutorganteFalecido': return _substring(valor, 32);
        case 'estadoOutorganteFalecido': return _substring(valor, 2);
        case 'cepOutorganteFalecido': return _substring(valor.replace(/\D/g, ''), 8);

        case 'nomeRepresentanteQuinze': return _substring(valor, 255);
        case 'cpfRepresentanteQuinze': return _substring(valor.replace(/\D/g, ''), 20);
        case 'rgRepresentanteQuinze': return _substring(valor.replace(/\D/g, ''), 20);
        case 'rgOERepresentanteQuinze': return _substring(valor, 50);
        case 'emailRepresentanteQuinze': return _substring(valor, 150);
        case 'celularRepresentanteQuinze': return _substring(valor.replace(/\D/g, ''), 15);
        case 'nomeSocial': return _substring(valor, 100);

        default:
            return valor;
    }
}

function _substring(valor, quantCaracteres) {
    if (typeof valor === 'number') {
        return Number(valor.toString().substring(0, quantCaracteres));
    } else {
        return valor.substring(0, quantCaracteres);
    }
}